import { useMutation, useQueryClient } from '@tanstack/react-query';
import { userConfigService } from '../../services/UserConfigService';
import type { UserConfig } from '../../types/userConfig';
import { toastMutationErrorKeys } from '../../query/mutationToasts';
import { userConfigQueryKeys } from '../userConfigQueryKeys';

function isLastSeenOnlyUpdate(partial: UserConfig): boolean {
  const keys = (Object.keys(partial) as Array<keyof UserConfig>).filter(
    (key) => partial[key] !== undefined,
  );
  return keys.length === 1 && keys[0] === 'platformChatLastSeenMessageIds';
}

export function useUpdateUserConfigMutation() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (partial: UserConfig) =>
      userConfigService.updateConfig(partial),
    onSuccess: (_data, partial) => {
      // Last-seen map is applied locally already; refetching the whole config
      // causes write storms and can overwrite concurrent local merges.
      if (isLastSeenOnlyUpdate(partial)) {
        return;
      }
      void queryClient.invalidateQueries({
        queryKey: userConfigQueryKeys.config(),
      });
    },
    onError: (error) => {
      void toastMutationErrorKeys(
        error,
        'settings.userConfig.saveErrorTitle',
        'settings.userConfig.saveErrorDescription',
      );
    },
  });
}
